import { BaseSearchDTO } from "../API";

export interface ValuationQuoteSearchDTO extends BaseSearchDTO {
  filters?: {
    crmLeadId?: string;
    statusId?: number;
  };
}
